export default {"src":"/_next/static/media/logo.94db74a8.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};